import { Host, h } from '@stencil/core';
export class AibaHeroImage {
  constructor() {
    this.getImageType = (url) => {
      const x = url.split('?');
      const type = x[0].split('.', -1);
      return type[type.length - 1];
    };
    this.renderPictureTag = () => {
      var _a, _b;
      const sourceArray = [];
      (_a = this.image) === null || _a === void 0 ? void 0 : _a.forEach((imgObj) => {
        (imgObj === null || imgObj === void 0 ? void 0 : imgObj.src) && sourceArray.push(h("source", { srcSet: imgObj === null || imgObj === void 0 ? void 0 : imgObj.src, media: `screen and (min-width: ${imgObj === null || imgObj === void 0 ? void 0 : imgObj.viewport})`, type: `image/${this.getImageType(imgObj === null || imgObj === void 0 ? void 0 : imgObj.src)}` }));
      });
      return (h("div", { class: "hero-image__image-block" }, h("picture", null, ...sourceArray, h("img", Object.assign({}, (this.fetchpriority && !this.loading && { fetchPriority: this.fetchpriority }), (this.loading && { loading: this.loading }), { src: (_b = this.image[this.image.length - 1]) === null || _b === void 0 ? void 0 : _b.src, alt: this.altText ? this.altText : 'image-alt', class: 'hero-image__image-block__welcomeBlock hero-image__image-block__image' }))), this.Children));
    };
    this.styles = undefined;
    this.classes = undefined;
    this.loading = undefined;
    this.fetchpriority = 'high';
    this.image = undefined;
    this.altText = undefined;
    this.title = undefined;
    this.h1Title = undefined;
    this.subTitle = undefined;
    this.description = undefined;
    this.titlePosition = undefined;
  }
  render() {
    var _a;
    if (typeof this.image === 'string') {
      if (this.image)
        this.image = JSON.parse(this.image);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `hero-image ${this.title ? 'title' : this.h1Title ? 'h1Title' : ''}` }, ((_a = this.image) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.renderPictureTag(), this.title && (h("div", { class: `hero-title-block ${this.titlePosition ? this.titlePosition : 'top-center'}` }, h("h2", { innerHTML: this.title }), this.subTitle && h("h3", { innerHTML: this.subTitle }), this.description && h("p", null, this.description))), this.h1Title && (h("div", { class: `hero-title-block ${this.titlePosition ? this.titlePosition : 'top-center'}` }, h("h1", { innerHTML: this.h1Title }), this.subTitle && h("h2", { innerHTML: this.subTitle }), this.description && h("p", null, this.description))))));
  }
  static get is() { return "aiba-hero-image"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-hero-image.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-hero-image.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "loading": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'lazy' | 'auto' | 'eager'",
          "resolved": "\"auto\" | \"eager\" | \"lazy\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading",
        "reflect": false
      },
      "fetchpriority": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "fetchpriority",
        "reflect": false,
        "defaultValue": "'high'"
      },
      "image": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "| any\n    | {\n        src: string;\n        viewport: string;\n      }[]",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "image",
        "reflect": false
      },
      "altText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "alt-text",
        "reflect": false
      },
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "h1Title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "h-1-title",
        "reflect": false
      },
      "subTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sub-title",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "description",
        "reflect": false
      },
      "titlePosition": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'bottom-center' | 'top-center' | 'left-center'",
          "resolved": "\"bottom-center\" | \"left-center\" | \"top-center\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title-position",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-hero-image.js.map
